/**
 * FAQ: one answer open at a time. Native <details name> already does this; this covers browsers without it.
 */
(() => {
  const init = (list) => {
    const items = Array.from(list.querySelectorAll('details'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) {
          return;
        }
        items.forEach((other) => {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-faq]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
